<app-review-section
  *ngIf="applicationData"
  [isDetailsView]="true"
  [title]="'app.navigation.doc_upload' | translate"
  [applicationId]="applicationData.application_id"
  [sectionId]="SectionIdentifier.Document_Submission"
  class="process-document-container component-container">
  <div *ngIf="documentsData.length" class="for-screen">
    <div
      *ngFor="let object of documentsData; let index = index"
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-font-size">
      <div *ngIf="object.sk_document_type === 'site_plan'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'lookup.' + documentTypeKey + '.options.site_plan.name' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'floor_plan'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'lookup.' + documentTypeKey + '.options.floor_plan.name' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'unit_certificate'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.unit_certificate.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'na_protection_certificate'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.na_protection_certificate.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'vde_documents'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'lookup.' + documentTypeKey + '.options.vde_documents.name' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'data_sheet_modules'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.data_sheet_modules.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'data_sheet_generating_unit'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.data_sheet_generating_unit.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'overview_plan_single_pole'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.overview_plan_single_pole.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'pole_circuit_diagram_1'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.pole_circuit_diagram_1.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'license_agreement'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.license_agreement.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'site_electricity_document'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.site_electricity_document.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'floor_plan_basement'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.floor_plan_basement.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'drinking_water_registration'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.drinking_water_registration.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'crane_con_with_electric_drive'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.crane_con_with_electric_drive.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'inspection_sticker'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.inspection_sticker.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'proof_of_landowner'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.proof_of_landowner.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'approval_empty_pipe'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.approval_empty_pipe.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'current_account'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.current_account.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'excerpt_or_overview_plan'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.excerpt_or_overview_plan.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'ordonance_clearence'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">
          {{ 'lookup.' + documentTypeKey + '.options.ordonance_clearence.name' | translate }}
        </div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'other'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ object.name }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'power_of_attorney_1'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.power_of_attorney_1' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'e_1_application'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.e_1_application' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'e_2_data_sheet'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.e_2_data_sheet' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'e_3_memory_data'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.e_3_memory_data' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'e_4_uniform_certificate'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.e_4_uniform_certificate' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'e_6_certificate_for_network'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.e_6_certificate_for_network' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'e_7_requirements_for_test_report'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.e_7_requirements_for_test_report' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'b_11_overview_circuit_diagram'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.b_11_overview_circuit_diagram' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'registration_for_network_connection'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.registration_for_network_connection' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'site_plan_or_area_map'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.site_plan_or_area_map' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'proof_of_conformity_certificates_modules'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.proof_of_conformity_certificates_modules' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'proof_of_conformity_certificates_storage'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.proof_of_conformity_certificates_storage' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'measuring_concept'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.measuring_concept' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'e_5_test_report'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.e_5_test_report' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'e_8_commissioning_protocol'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.e_8_commissioning_protocol' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'ground_protocol'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.ground_protocol' | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            id="other-doc-download-btn-{{ index }}"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'pv_device_consumer'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.' + object.sk_document_type | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            [id]="object.name"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'bhkw_kwk_device_consumer'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.' + object.sk_document_type | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            [id]="object.name"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div *ngIf="object.sk_document_type === 'storage_consumer'" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.' + object.sk_document_type | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            [id]="object.name"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>

      <div
        *ngIf="object.sk_document_type === 'customer_power_of_attorney'"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 row-data">
        <div class="ui-g-4 field-label text-right-align">{{ 'documents.' + object.sk_document_type | translate }}</div>
        <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12">
          <button
            (click)="downloadDocument(object.document_id, object.filename)"
            class="view-btn-width"
            [id]="object.name"
            label="{{ 'view-button-label' | translate }}"
            pButton
            type="button"></button>
        </div>
        <div class="ui-g-4 field-label">{{ object.filename }}</div>
      </div>
    </div>

    <div *ngIf="showNewDocuments && !isReadOnly" [formGroup]="newDocumentsGroup">
      <div
        *ngFor="let document of newDocuments.controls; let i = index"
        class="form-background top-bottom-margin flex-row"
        formArrayName="newDocuments">
        <div [formGroupName]="i" class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-10 ui-sm-10 ui-xs-10">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
            <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
              <input class="doc-submit-inputs" formControlName="documentName" pInputText type="text" />
            </div>
            <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
              <p-fileUpload
                #documentUploader
                (onSelect)="onDocumentUpload($event, i, documentUploader)"
                [disabled]="!document.get('documentName').valid"
                chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                mode="basic"></p-fileUpload>
            </div>
            <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
              <i class="pi pi-info-circle hint-icon"></i>
            </div>
          </div>
        </div>

        <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-2 ui-sm-2 ui-xs-2 field-rows file-name-section">
          <a *ngIf="document.value['fileName']" href="javascript:void(0)" (click)="downloadDocument(i, document.value['fileName'])">
            {{ document.value['fileName'] }}
          </a>
          <i (click)="removeDocument(i)" class="pi pi-trash pointer-cursor delete-icon"></i>
        </div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
        <div class="ui-g-12 margin-align add-button-row form-font-size">
          <i
            (click)="addDocument()"
            class="pi pi-plus plus-icon new-facility-plus-icon"
            id="base-data-add-facility"
            tabindex="0"
            appEnterClick></i>
          <label class="ui-g-5 field-label" for="base-data-add-facility">
            {{ 'facilities-data.form-fields.add-document-button' | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!documentsData.length" class="text-center for-screen">-</div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 comment-section">
    <div class="comment-section-title">{{ 'documents.comment' | translate }}</div>
    <div id="comment" class="comment-box" *ngIf="comment.length" [innerHTML]="comment" cols="30" rows="10"></div>
    <div *ngIf="!comment">-</div>
  </div>

  <div *ngIf="connectionDate || desiredDate" class="ui-g-12">
    <div class="margin-header-align text-uppercase page-title">{{ 'basic-profile.jurisdiction.inquiry' | translate }}</div>
    <div *ngIf="connectionDate" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-margin">
      <div class="ui-g-12 dates-row margin-align form-font-size">
        <label class="ui-g-3 field-label text-right-align margin-right-align" for="doc-sub-des-date">
          {{ 'documents.building_conn_date' | translate }}
        </label>
        <p-calendar
          tabIndex="0"
          appCalendarEscapeClose
          [ngModel]="connectionDate"
          [disabled]="true"
          [dateFormat]="dateFormat.dateFormat"
          class="doc-submit-datepicker"
          dataType="string"
          id="building-conn-date"
          inputId="basic"></p-calendar>
      </div>
    </div>
    <div *ngIf="desiredDate" class="ui-g-12 top-margin">
      <div class="ui-g-12 dates-row margin-align form-font-size">
        <label class="ui-g-3 field-label text-right-align margin-right-align" for="doc-sub-des-date">
          {{ 'facilities-data.form-fields.des_date' | translate }}
        </label>
        <p-calendar
          tabIndex="0"
          appCalendarEscapeClose
          [ngModel]="desiredDate"
          [disabled]="true"
          [dateFormat]="dateFormat.dateFormat"
          class="doc-submit-datepicker"
          dataType="string"
          id="doc-sub-des-date"
          inputId="basic"></p-calendar>
      </div>
    </div>
  </div>

  <div
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
    *ngIf="isPowerFacilityAvailable && currentInstallationFlow === installationFlowType.NewInstallation">
    <div class="p-field-checkbox">
      <p-checkbox appEnterClick binary="true" inputId="binary" [(ngModel)]="powerTermsChecked" [readonly]="true"></p-checkbox>
      <label>{{ 'documents.terms-for-power' | translate }}</label>
    </div>
  </div>
  <div
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
    *ngIf="
      isGasFacilityAvailable &&
      (currentInstallationFlow === installationFlowType.NewInstallation ||
        (!hideGasConfirmationCheckboxes && currentInstallationFlow === installationFlowType.UpdateInstallation))
    ">
    <div class="p-field-checkbox">
      <p-checkbox appEnterClick binary="true" inputId="binary" [(ngModel)]="gasTermsChecked1" [readonly]="true"></p-checkbox>
      <label>{{ 'documents.terms-for-gas1' | translate }}</label>
    </div>
    <div class="p-field-checkbox">
      <p-checkbox appEnterClick binary="true" inputId="binary" [(ngModel)]="gasTermsChecked2" [readonly]="true"></p-checkbox>
      <label>{{ 'documents.terms-for-gas2' | translate }}</label>
    </div>
    <div class="p-field-checkbox" *ngIf="showCheckbox3ForGas">
      <p-checkbox appEnterClick binary="true" inputId="binary" [(ngModel)]="gasTermsChecked3" [readonly]="true"></p-checkbox>
      <label>
        <b>{{ 'documents.terms-for-gas3' | translate }}</b>
      </label>
    </div>
  </div>
  <div
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
    *ngIf="isWaterFacilityAvailable && currentInstallationFlow === installationFlowType.NewInstallation">
    <div class="p-field-checkbox">
      <p-checkbox appEnterClick binary="true" inputId="binary" [(ngModel)]="waterTermsChecked" [readonly]="true"></p-checkbox>
      <label class="terms-labels">
        {{ 'documents.condition-start' | translate }}
        <ul>
          <li>{{ 'documents.terms-for-water.condition-1' | translate }}</li>
          <li>{{ 'documents.terms-for-water.condition-2' | translate }}</li>
          <li>{{ 'documents.terms-for-water.condition-3' | translate }}</li>
          <li>{{ 'documents.terms-for-water.condition-4' | translate }}</li>
        </ul>
      </label>
    </div>
  </div>
  <div
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
    *ngIf="isHeatingFacilityAvailable && currentInstallationFlow === installationFlowType.NewInstallation">
    <div class="p-field-checkbox">
      <p-checkbox appEnterClick binary="true" inputId="binary" [(ngModel)]="heatingTermsChecked" [readonly]="true"></p-checkbox>
      <label class="terms-labels">
        <ul>
          <li>{{ 'documents.terms-for-heating.condition-1' | translate }}</li>
          <li>{{ 'documents.terms-for-heating.condition-2' | translate }}</li>
        </ul>
      </label>
    </div>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showInstallationComment">
    <div class="comment-section-title">{{ 'documents.additional-comment' | translate }}</div>
    <div
      id="initialComment"
      class="comment-box"
      *ngIf="installationComment.length"
      [innerHTML]="installationComment"
      cols="30"
      rows="10"></div>
    <div *ngIf="!installationComment">-</div>
  </div>
</app-review-section>
